/**
 * Delay execution for a specified duration
 *
 * @param ms - Time to wait in milliseconds
 * @returns Promise that resolves after the specified time
 */
export const sleep = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
